<script setup>
// Célula de uma unidade no espelho de vendas — cor por status, clique abre o
// painel (UnitDrawer) via `select`.
import { computed } from 'vue';

const props = defineProps({
  unit: { type: Object, required: true },
  // Usado pelo `SalesMirror` em modo `selectable` (Task 13, aba "Unidade" do
  // negócio): torna a célula inerte (sem clique) para unidades que não
  // podem ser escolhidas ali — sem afetar o modo normal (espelho do
  // empreendimento), onde toda célula abre o drawer independente do status.
  disabled: { type: Boolean, default: false },
});
const emit = defineEmits(['select']);

const STYLES = {
  available:
    'bg-n-teal-9/15 text-n-teal-11 border-n-teal-9/40 hover:bg-n-teal-9/25',
  reserved:
    'bg-n-amber-9/20 text-n-amber-11 border-n-amber-9/50 hover:bg-n-amber-9/30',
  sold: 'bg-n-blue-11 text-white border-n-blue-11',
  blocked: 'bg-n-slate-4 text-n-slate-10 border-n-slate-6 line-through',
};

const cls = computed(() => STYLES[props.unit.status] || STYLES.blocked);

const handleClick = () => {
  if (props.disabled) return;
  emit('select', props.unit);
};
</script>

<template>
  <button
    type="button"
    class="flex flex-col items-center justify-center w-[76px] h-11 rounded-lg border text-xs font-medium tabular-nums transition-colors disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:bg-transparent"
    :class="cls"
    :disabled="disabled"
    :title="`${unit.number} · ${unit.typology || ''}`"
    @click="handleClick"
  >
    <span>{{ unit.number }}</span>
    <span
      v-if="unit.typology"
      class="text-[10px] font-normal opacity-80 truncate max-w-full px-1"
    >
      {{ unit.typology }}
    </span>
  </button>
</template>
